import { registerSW } from 'virtual:pwa-register';

export let updateServiceWorker: (reloadPage?: boolean) => Promise<void> = async () => undefined;

if (import.meta.env.DEV) {
  void navigator.serviceWorker
    ?.getRegistrations()
    .then(async (registrations) => {
      await Promise.all(registrations.map((registration) => registration.unregister()));
      if ('caches' in window) {
        await Promise.all((await caches.keys()).map((name) => caches.delete(name)));
      }
    })
    .catch(() => undefined);
} else {
  const updatingExistingWorker = Boolean(navigator.serviceWorker?.controller);
  let activationReloaded = false;
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (!updatingExistingWorker || activationReloaded) return;
    activationReloaded = true;
    window.location.reload();
  });
  updateServiceWorker = registerSW({
    immediate: true,
    onRegisteredSW(_serviceWorkerUrl, registration) {
      if (!registration) return;
      const check = () => void registration.update().catch(() => undefined);
      window.setInterval(check, 5 * 60 * 1000);
      window.addEventListener('focus', check);
      window.addEventListener('online', check);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
    },
  });
}
